import type { TaskPriority } from "@/api/types";

export const PRIORITY_DOT: Record<TaskPriority, string> = {
  urgent: "bg-rose-500",
  high: "bg-orange-500",
  medium: "bg-blue-500",
  low: "bg-slate-300",
};

export const PRIORITY_RING: Record<TaskPriority, string> = {
  urgent: "border-rose-500 text-rose-700 bg-rose-50",
  high: "border-orange-400 text-orange-700 bg-orange-50",
  medium: "border-blue-400 text-blue-700 bg-blue-50",
  low: "border-slate-300 text-slate-600 bg-slate-50",
};

export const PRIORITY_LABEL: Record<TaskPriority, string> = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const PRIORITIES: TaskPriority[] = ["low", "medium", "high", "urgent"];

/** Sort order: highest priority first. */
export const PRIORITY_RANK: Record<TaskPriority, number> = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};
